import React from "react";
import { nf } from "./format";

export default function Funnel({ steps, totals }) {
  const vals = steps.map(([k]) => totals?.[k] ?? 0);
  const max = Math.max(...vals, 0);
  return (
    <div className="an-funnel" role="list">
      {steps.map(([k, label], i) => {
        const v = vals[i];
        const w = max ? Math.max((v / max) * 100, v ? 2 : 0) : 0;
        const prev = i ? vals[i - 1] : null;
        const conv = prev ? `${Math.round((v / prev) * 100)}%` : null;
        return (
          <div className="an-frow" role="listitem" key={k}>
            <span>{label}</span>
            <div className="an-ftrack">
              <div className="an-fbar" style={{ width: `${w}%`, opacity: 1 - i * 0.12 }} />
              <div className="an-fval" style={w > 30 ? { color: "#fff" } : { left: `calc(${w}% + 10px)` }}>
                {nf(v)}
                {conv && <small>{conv} от предыдущего</small>}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
